<div class="flex flex-column p-2 gap-20 justify-content-between h-full">
    <div class="flex flex-column">
        <span class="p-float-label">
            <input
                pInputText
                [placeholder]="'default-cm-filterName' | translate: 'Filter Name'"
                [ngClass]="{ 'ng-invalid ng-dirty': isDuplicate }"
                class="w-full"
                id="filterName"
                (ngModelChange)="valueChange($event)"
                [(ngModel)]="value"
            />
            <label for="filterName">{{ 'default-cm-filterName' | translate: 'Filter Name' }}</label>
        </span>
        @if (isDuplicate) {
            <small class="text-red-500">{{
                'default-cm-filterNameExists' | translate: 'Filter name already exists'
            }}</small>
        }
        <!-- <p-checkbox label="Save as default list" [binary]="true" [(ngModel)]="value.saveDefault" /> -->
    </div>
    <div class="flex gap-16">
        <p-button
            class="w-full"
            [outlined]="true"
            [label]="'default-cm-cancel' | translate: 'Cancel'"
            styleClass="w-full h-3rem"
            (onClick)="onButtonClick()"
        ></p-button>
        <p-button
            class="w-full"
            [label]="'default-cm-save' | translate: 'Save'"
            styleClass="w-full h-3rem"
            [disabled]="!value || presentNames.includes(value)"
            (onClick)="onButtonClick(value)"
        ></p-button>
    </div>
</div>
